__turbopack_context__.v({
  "icon": "SingleStat-module-scss-module__eEl-1a__icon",
  "root": "SingleStat-module-scss-module__eEl-1a__root",
});
